// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as PnMFareEstimateModalLayoutModuleScss from "../styles/PnMFareEstimateModalLayout.module.scss";

var styles = PnMFareEstimateModalLayoutModuleScss;

function PnMFareEstimateModalLayoutCmp(Props) {
  var title = Props.title;
  var sub_title = Props.sub_title;
  var title_mobile = Props.title_mobile;
  var children = Props.children;
  var close_modal = Props.close_modal;
  return React.createElement("div", {
              className: styles["estimate-layout-container"]
            }, React.createElement("section", {
                  className: styles["title-container"]
                }, React.createElement("p", {
                      className: styles.title
                    }, title), React.createElement("p", {
                      className: styles["sub-title"]
                    }, sub_title), React.createElement("p", {
                      className: styles["title-mobile"]
                    }, title_mobile)), React.createElement("section", {
                  className: styles["form-container"]
                }, children), React.createElement("button", {
                  className: styles["close-modal-button"],
                  onClick: (function (param) {
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: "https://dom-content-vault-prod-cdn-assets.porter.in/cross_icon_29cf70155f/cross_icon_29cf70155f.svg",
                      height: 24.0,
                      width: 24.0,
                      quality: 100.0,
                      alt: "close"
                    })));
}

var make = PnMFareEstimateModalLayoutCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
